import { compose, withState, withHandlers } from 'incompose';

export default compose(
  withState('isDialogOpen', 'setIsDialogOpen', false),
  withHandlers({
    openDialog: ({ setIsDialogOpen }) => () => setIsDialogOpen(true),
    closeDialog: ({ setIsDialogOpen }) => () => setIsDialogOpen(false),
  }),
);
